import axios from '@MyAxios';

export async function getUserDetails(id, params = {}) {
  // params can include: tab, page, perPage, groupsPage, communitiesPage, connectionsPage
  const response = await axios.get(`/admin/users/details/${id}`, { params });
  return response.data;
}